<template>
  <div v-loading="$wait.waiting(_uid)" class="card">
    <div class="card-content">
      <form ref="form" @submit.prevent="handleUpdateUser">
        <div class="text-right control-button-wrapper pt-xxs">
          <acl :permissions="['companies_users_destroy']">
            <button
              type="button"
              class="btn btn-danger btn-wd submit-button mr-xxs"
              @click="handleDeleteUser"
            >
              Delete
            </button>
          </acl>

          <router-link
            :to="{ name: 'companies_users@show', params: { id: user.id } }"
          >
            <button
              class="btn btn-cancel btn-primary btn-wd submit-button mr-xxs"
            >
              Cancel
            </button>
          </router-link>

          <acl :permissions="['companies_users_update']">
            <button
              type="submit"
              class="btn btn-info btn-fill btn-wd submit-button"
              :class="{ loading: $wait.waiting(_uid) }"
            >
              Update
              <i
                v-show="$wait.waiting(_uid)"
                class="fas fa-circle-notch loading-icon"
              />
            </button>
          </acl>
        </div>

        <div class="row">
          <div class="card-header">
            <h4 class="title mt-xxs">Personal Information</h4>
          </div>
          <div class="col-md-6">
            <fg-input
              v-model="model.name"
              type="text"
              required
              label="First Name"
              placeholder="First Name"
            />

            <fg-input
              v-model="model.surname"
              type="text"
              required
              label="Last Name"
              placeholder="Last Name"
            />
          </div>

          <div class="col-md-6">
            <fg-input
              v-model="model.username"
              type="email"
              required
              label="Username"
              placeholder="Username"
            />
            <acl :roles="['Admin', 'Customer Support']">
              <fg-input
                v-model="model.password"
                type="password"
                label="Password"
              />

              <fg-input
                v-model="model.passwordConfirmation"
                type="password"
                label="Confirm Password"
              />
            </acl>
          </div>
        </div>

        <acl :roles="['Admin', 'Customer Support']">
          <div class="">
            <hr />
            <div class="row mb-s pb-s">
              <div class="card-header">
                <h4 class="title">User Type/Role</h4>
              </div>

              <div class="col-md-6 col-xs-12">
                <div v-if="operational.externalAcl.length">
                  <div
                    v-for="acl in operational.externalAcl"
                    :key="acl.id + ':key'"
                    class="form-group"
                  >
                    <p-switch
                      :value="model.acls[acl.id].active"
                      type="primary"
                      class="mr-xs"
                      @input="toggleAcl(acl)"
                    />
                    <label>{{ acl.name }}</label>
                  </div>
                </div>

                <div v-if="operational.internalAcl.length">
                  <hr />
                  <div
                    v-for="acl in operational.internalAcl"
                    :key="acl.id + ':key'"
                    class="form-group"
                  >
                    <p-switch
                      :value="model.acls[acl.id].active"
                      type="primary"
                      class="mr-xs"
                      @input="toggleAcl(acl)"
                    />
                    <label>{{ acl.name }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="model.isTrainee" class="row mb-s">
              <div class="card-header">
                <h4 class="title">Operational Information</h4>
              </div>
              <div class="col-md-4 col-xs-12">
                <h5 class="title">Registry, Purpose, Equipment</h5>
                <div
                  v-for="rpe in operational.rpes"
                  :key="rpe.id"
                  class="form-group"
                >
                  <p-switch
                    v-model="model.companyRpes[rpe.id].active"
                    type="primary"
                    class="mr-xs"
                  />
                  <label>{{ rpe.name }}</label>
                </div>
              </div>

              <div class="col-md-4 col-xs-12">
                <h5 class="title">Role(s)</h5>
                <div
                  v-for="role in operational.roles"
                  :key="role.id"
                  class="form-group"
                >
                  <p-switch
                    v-model="model.companyRoles[role.id].active"
                    type="primary"
                    class="mr-xs"
                  />
                  <label>{{ role.name }}</label>
                  <fg-input
                    v-show="model.companyRoles[role.id].active"
                    v-model="model.companyRoles[role.id].licence"
                    type="text"
                    placeholder="Licence"
                    class="mt-xxs"
                    :value="model.companyRoles"
                  />
                </div>
              </div>

              <div class="col-md-4 col-xs-12">
                <h5 class="title">Hemisphere</h5>
                <div class="form-group">
                  <p-switch
                    :value="model.hemisphere === 'N'"
                    type="primary"
                    class="mr-xs"
                    @input="setHemisphere('N')"
                  />
                  <label>Northern</label>
                </div>

                <div class="form-group">
                  <p-switch
                    :value="model.hemisphere === 'S'"
                    type="primary"
                    class="mr-xs"
                    @input="setHemisphere('S')"
                  />
                  <label>Southern</label>
                </div>
              </div>

              <div class="col-xs-12 mt-s">
                <label class="mr-xs">Subscription Renewal</label>

                <div class="clearfix" />

                <el-date-picker
                  v-model="model.subscription"
                  type="date"
                  placeholder="Pick a day"
                  :editable="false"
                />
              </div>
            </div>
          </div>
        </acl>

        <hr />

        <div class="row mb-s pb-s">
          <div class="card-header">
            <h4 class="title mt-xxs">Settings</h4>
          </div>

          <div class="col-md-6 col-xs-12">
            <div class="form-group">
              <div>
                <label for="notification" class="mr-xs"> Notifications </label>
                <p-switch
                  v-model="model.settings.notifications"
                  type="primary"
                  class="mr-xs"
                />
                <div>
                  <fg-input
                    v-model="model.email"
                    type="email"
                    required
                    label="Email"
                    placeholder="Email"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix" />
        </div>
        <hr />
        <div class="row mb-s pb-s">
          <div class="col-md-6 col-xs-12">
            <div class="form-group">
              <div>
                <div class="mb-5">
                  <label for="suspend" class="mr-xs"> Suspend </label>
                  <p-switch
                    v-model="model.settings.suspend.status"
                    type="primary"
                    class="mr-xs"
                    @input="(value) => changeNotification(value)"
                  />
                </div>

                <div v-if="model.settings.suspend.status">
                  <div class="mb-10">
                    <div>
                      <small for="notification" class="mr-xs">
                        Training continues to be delivered while trainee is
                        suspended. Notifications and status boards can be
                        enabled while suspended.
                      </small>
                    </div>

                    <div>
                      <div>
                        <label> Date of return: </label>
                        <small for="notification" class="mr-xs">
                          (leave blank to suspend until subscription renewal)
                        </small>
                      </div>
                      <el-date-picker
                        v-model="model.settings.suspend.endDate"
                        align="right"
                        type="date"
                        placeholder=""
                        format="yyyy/MM/dd"
                        value-format="yyyy-MM-dd"
                        :picker-options="dateRange"
                      >
                      </el-date-picker>
                    </div>
                  </div>

                  <div class="row mt-5 mb-5">
                    <div class="col-md-5 col-xs-12">
                      <label for="notification" class="mr-xs">
                        Display on training status board
                      </label>
                    </div>
                    <div class="col-md-7 col-xs-12">
                      <p-switch
                        v-model="model.settings.suspend.showTrainingStatus"
                        :active-value="true"
                        :inactive-value="false"
                        type="primary"
                        class="mr-xs"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-5 col-xs-12">
                      <label for="notification" class="mr-xs">
                        Display on events status board
                      </label>
                    </div>
                    <div class="col-md-7 col-xs-12">
                      <p-switch
                        v-model="model.settings.suspend.showEventsStatus"
                        :active-value="true"
                        :inactive-value="false"
                        type="primary"
                        class="mr-xs"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix" />
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import HelperDate from "@helpers/dates";
import PSwitch from "@components/UIComponents/Switch.vue";
import { DatePicker } from "element-ui";
import _get from "lodash.get";
import arrToObj from "@helpers/arrToObj";
import addPropToObj from "@helpers/addPropToObj";
import { mapActions, mapGetters, mapMutations } from "vuex";
import toggleAcl from "./providers/toggleAcl";
import setHemisphere from "./providers/setHemisphere";
import getModelOperational from "./providers/getModelOperational";
import checkRpeAndRole from "./providers/checkRpeAndRole";
import getSettings from "./providers/getSettings";
import parseSettings from "./providers/parseSettings";
import parseAcl from "./providers/parseAcl";
import _capitalize from "lodash.capitalize";
import swal from "sweetalert2";

export default {
  components: {
    PSwitch,
    [DatePicker.name]: DatePicker,
  },
  data() {
    const model = {
      name: "",
      surname: "",
      email: "",
      username: "",
      hemisphere: "N",
      companyRpes: {},
      companyRoles: {},
      subscription: HelperDate.formatDate(this.moment()),
      acls: {},
      password: "",
      passwordConfirmation: "",
      settings: {
        notifications: false,
        suspend: {
          status: false,
          endDate: null,
          showTrainingStatus: false,
          showEventsStatus: false,
        },
      },
    };

    return {
      model,
      internalAcl: [],
      externalAcl: [],
      dateRange: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() || time.getTime() > model.subscription
          );
        },
      },
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("companyUserStore", { storedOperational: "operational" }),
    ...mapGetters("companyUserStore", ["acl", "user", "settings"]),
    operational() {
      [this.addRpes, this.addRoles, this.addAcl].forEach((fn) =>
        fn(this.storedOperational, this.user)
      );

      const operationalAcl = this.storedOperational.acl || [];

      return {
        ...this.storedOperational,
        ...parseAcl(operationalAcl),
      };
    },
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      await this.getCompanyOperationalInformation();
      const userId = _get(this, "$route.params.id");
      await this.getUser(userId);
      this.fillFields();
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    _capitalize,
    getSettings,
    parseSettings,
    ...mapMutations("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    ...mapActions("companyUserStore", [
      "getUser",
      "getCompanyOperationalInformation",
      "updateCompanyUser",
      "deleteUser",
    ]),
    fillFields() {
      const subscription = _get(this, "user.subscription.end", new Date());
      const initialModel = {
        subscription: HelperDate.formatDate(subscription),
        settings: this.parseSettings(this.settings),
      };

      const newProps = [
        "name",
        "surname",
        "username",
        "email",
        "hemisphere",
      ].reduce(
        (acc, current) => ({
          ...acc,
          [current]: this.user[current],
        }),
        initialModel
      );

      this.model = {
        ...this.model,
        ...newProps,
      };
    },
    addRpes(operational, savedUser) {
      const rpes = _get(operational, "rpes");
      if (!rpes) {
        return;
      }

      if (!savedUser.company.rpe) {
        return;
      }

      const parsedRpes = rpes.map((rpe) => {
        const isActive = savedUser.company.rpe.some(({ id }) => id === rpe.id);

        return addPropToObj(rpe, "active", isActive);
      });

      this.model.companyRpes = arrToObj(parsedRpes);
    },
    addRoles(operational, savedUser) {
      const roles = _get(operational, "roles");
      if (!roles) {
        return;
      }

      if (!savedUser.company.roles) {
        return;
      }

      const parsedRoles = roles
        .map((role) => {
          const isActive = savedUser.company.roles.some(
            ({ id }) => id === role.id
          );

          return addPropToObj(role, "active", isActive);
        })
        .map((role) => {
          const foundRole =
            savedUser.company.roles.find(({ id }) => id === role.id) || {};

          return addPropToObj(role, "licence", foundRole.licence);
        });

      this.model.companyRoles = arrToObj(parsedRoles);
    },
    addAcl(operational, savedUser) {
      const acls = _get(operational, "acl");
      if (!acls) {
        return;
      }

      if (!savedUser.acl.roles) {
        return;
      }

      const parsedAcls = acls.map((role) => {
        const isActive = savedUser.acl.roles.some(({ id }) => id === role.id);

        return addPropToObj(role, "active", isActive);
      });

      this.model.isTrainee = parsedAcls.some(
        (acl) => acl.active && acl.name === "Trainee"
      );

      this.model.acls = arrToObj(parsedAcls);
    },
    setHemisphere,
    toggleAcl,
    getModelOperational,
    checkRpeAndRole,
    _getIdAndLicence(list) {
      return list.map((option) =>
        "licence" in option
          ? { id: option.id, licence: option.licence }
          : option.id
      );
    },
    _getValuesFromDataModel(keys) {
      return keys.reduce(
        (acc, prop) => ({
          ...acc,
          [prop]: this.model[prop],
        }),
        {}
      );
    },
    getApiModel({ roles, companyRpes, companyRoles }) {
      const apiModel = {
        roles,
        id: this.user.id,
        ...this._getValuesFromDataModel([
          "name",
          "surname",
          "email",
          "username",
          "settings",
        ]),
      };

      if (this.model.isTrainee) {
        Object.assign(apiModel, {
          companyRpes,
          companyRoles,
          subscription: HelperDate.formatDate(this.model.subscription),
          ...this._getValuesFromDataModel(["hemisphere"]),
        });
      }

      return apiModel;
    },
    async handleUpdateUser() {
      const [companyRpes, roles, companyRoles] = this.getModelOperational();

      const isValid = this.checkRpeAndRole(companyRpes, companyRoles);
      if (!isValid) {
        return;
      }

      const apiModel = this.getApiModel({ roles, companyRpes, companyRoles });

      try {
        await this.updateCompanyUser(apiModel);

        this.$notify({
          message: "Data updated successfully!",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });

        setTimeout(
          () =>
            this.$router.push({
              name: "companies_users@show",
              params: { id: this.user.id },
            }),
          500
        );
      } catch (error) {
        this.addNewError(error);
      }
    },
    async handleDeleteUser() {
      try {
        this.$wait.start(this._uid);

        const shouldDelete = await swal({
          title: "Confirmation",
          text: "Do you really want to delete this user?",
          type: "warning",
          buttonsStyling: false,
          reverseButtons: true,
          confirmButtonClass: "btn ml-xs btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          showCancelButton: true,
        });

        if (!shouldDelete) {
          return;
        }

        await this.deleteUser(this.user.id);

        return this.$router.push({ name: "companies_users@index" });
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    changeNotification(value) {
      this.model.settings.notifications = !value;
    },
  },
};
</script>
<style></style>
